/**
 * COURE.HUB.DS.USSD.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ApiMethodType } from './apiMethodType';
import { Channel } from './channel';
import { ContentSource } from './contentSource';
import { PageConfigurationProcessDto } from './pageConfigurationProcessDto';
import { PagePosition } from './pagePosition';
import { PostMethodRequestEnum } from './postMethodRequestEnum';
import { ResponseType } from './responseType';

export interface PageConfigDto { 
    pageName?: string;
    pageId?: string;
    serviceProviderId?: string;
    shortCode?: string;
    keyNumber?: string;
    responseType?: ResponseType;
    pagePosition?: PagePosition;
    displayText?: string;
    nextPage?: string;
    previousPage?: string;
    pages?: Array<PageConfigurationProcessDto>;
    userInput?: string;
    deliveryChannel?: Channel;
    contentSourceParam?: string;
    contentUrl?: string;
    apiMethodType?: ApiMethodType;
    postMethodRequestType?: PostMethodRequestEnum;
    contentSource?: ContentSource;
    partnerId?: string;
    partnerContentId?: string;
    airtelUrl?: string;
    errorMessage?: string;
    pageSetupStatus?: boolean;
    headerText?: string;
    campaignId?: string;
}